import { z } from 'zod';

const workingHoursDay = z.tuple([z.string(), z.string()]).nullable();

/** `HH:MM`, 24-hour — the same shape the working-hours tuples already use. */
const timeOfDay = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Expected a HH:MM time');

/**
 * Everything past `remindLongRunning` is `.optional()` rather than
 * `.default()` on purpose: this endpoint is a full replace (`PUT`), and the
 * mobile/desktop reminder screens still send only the three original fields.
 * Defaulting the newer ones would silently reset a user's email-reminder
 * choices every time they saved from one of those apps; leaving them
 * `undefined` lets the service skip them in the update instead.
 */
export const reminderSettingsSchema = z.object({
  workingHours: z.object({
    mon: workingHoursDay,
    tue: workingHoursDay,
    wed: workingHoursDay,
    thu: workingHoursDay,
    fri: workingHoursDay,
    sat: workingHoursDay,
    sun: workingHoursDay,
  }),
  remindNoTimer: z.boolean().default(true),
  remindLongRunning: z.boolean().default(true),
  emailEnabled: z.boolean().optional(),
  pushEnabled: z.boolean().optional(),
  remindDailyStart: z.boolean().optional(),
  dailyStartTime: timeOfDay.optional(),
  remindMissingEntries: z.boolean().optional(),
  missingEntriesTime: timeOfDay.optional(),
});
export type ReminderSettingsInput = z.infer<typeof reminderSettingsSchema>;

export const registerDeviceSchema = z.object({
  platform: z.enum(['ios', 'android', 'desktop']),
  pushToken: z.string().min(1),
});
export type RegisterDeviceInput = z.infer<typeof registerDeviceSchema>;
